"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealtimeEventType = void 0;
var RealtimeEventType;
(function (RealtimeEventType) {
    RealtimeEventType["SessionCreated"] = "SessionCreated";
    RealtimeEventType["InputAudioBufferStarted"] = "InputAudioBufferStarted";
    RealtimeEventType["InputAudioBufferStopped"] = "InputAudioBufferStopped";
    RealtimeEventType["InputAudioTranscriptDelta"] = "InputAudioTranscriptDelta";
    RealtimeEventType["InputAudioTranscriptDone"] = "InputAudioTranscriptDone";
    RealtimeEventType["InputTextCreated"] = "InputTextCreated";
    RealtimeEventType["OutputAudioBufferStarted"] = "OutputAudioBufferStarted";
    RealtimeEventType["OutputAudioBufferStopped"] = "OutputAudioBufferStopped";
    RealtimeEventType["OutputAudioTranscriptDelta"] = "OutputAudioTranscriptDelta";
    RealtimeEventType["OutputAudioTranscriptDone"] = "OutputAudioTranscriptDone";
    RealtimeEventType["InputAudioUploadStarted"] = "InputAudioUploadStarted";
    RealtimeEventType["InputAudioUploadCompleted"] = "InputAudioUploadCompleted";
    RealtimeEventType["OutputAudioUploadStarted"] = "OutputAudioUploadStarted";
    RealtimeEventType["OutputAudioUploadCompleted"] = "OutputAudioUploadCompleted";
    RealtimeEventType["OutputTextDelta"] = "OutputTextDelta";
    RealtimeEventType["OutputTextDone"] = "OutputTextDone";
})(RealtimeEventType || (exports.RealtimeEventType = RealtimeEventType = {}));
//# sourceMappingURL=event.js.map